// extracted by mini-css-extract-plugin
export default {"pageWrap":"Md-z","fullWidth":"Nd-z","heading":"Od-z","fullBleed":"Pd-z","hidden":"Qd-z"};